import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const HistoryFilters = ({ 
  searchTerm, 
  onSearchChange, 
  dateRange, 
  onDateRangeChange,
  completionFilter,
  onCompletionFilterChange,
  onClearFilters,
  resultCount 
}) => {
  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'week', label: 'Past Week' },
    { value: 'month', label: 'Past Month' },
    { value: '3months', label: 'Past 3 Months' }
  ];

  const completionOptions = [
    { value: 'all', label: 'All Entries' },
    { value: 'completed', label: 'High Completion' },
    { value: 'partial', label: 'Partial Completion' },
    { value: 'incomplete', label: 'Low Completion' }
  ];

  const hasActiveFilters = searchTerm || dateRange !== 'all' || completionFilter !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4">
      {/* Search and Quick Actions */}
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search goals, dates, or content..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        
        {hasActiveFilters && (
          <Button
            variant="outline"
            iconName="X"
            iconPosition="left"
            iconSize={16}
            onClick={onClearFilters}
            className="sm:w-auto"
          >
            Clear Filters
          </Button>
        )}
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={dateRange}
          onChange={onDateRangeChange}
          className="w-full"
        />
        
        <Select
          label="Completion Status"
          options={completionOptions}
          value={completionFilter}
          onChange={onCompletionFilterChange}
          className="w-full"
        />
      </div>
      {/* Results Summary */}
      <div className="flex items-center justify-between pt-2 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Search" size={16} />
          <span>
            {resultCount} {resultCount === 1 ? 'entry' : 'entries'} found
          </span>
        </div>
        
        {hasActiveFilters && (
          <div className="flex items-center space-x-1 text-xs text-accent">
            <Icon name="Filter" size={12} />
            <span>Filters active</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryFilters;